var version="9.6.2";export{version as v};
//# sourceMappingURL=package-d49cc941.js.map
